import { Injectable } from '@angular/core';
import { HttpNewService } from './application/http-new.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import {
    IHistoryDiag,
    IHistoryEventList,
    IHistoryVisit,
} from '../interfaces/history.interfaces';
import { IService, IServiceSize } from '../interfaces/services.interfaces';
import { dateToText } from '../components/application/global.function';
import { IResearchFileList } from '../interfaces/laboratory-services.interfaces';

@Injectable({
    providedIn: 'root',
})
export class ServicesService {
    public constructor(
        private httpNew: HttpNewService,
        private auth: AuthService,
    ) {}

    // /**
    //  * Список событий истории за указанный промежуток времени
    //  * @param parameters
    //  * @returns {Observable<IHistoryEventList[]>}
    //  */
    // public getHistoryEventList(parameters: {
    //     begin: string;
    //     end: string;
    // }): Observable<IHistoryEventList[]> {
    //     const { begin, end } = parameters;
    //     const url =
    //         '/api/patient/' +
    //         null +
    //         '/history/event?beginDate=' +
    //         begin +
    //         '&endDate=' +
    //         end;
    //     return this.httpNew.get(url, null);
    // }

    /**
     * Получить список услуг
     * @param orderBy = acs / desc
     */

    public getServices(
        beginDate: Date | null,
        endDate: Date | null,
        pStart?: number,
        pEnd?: number,
        orderBy: string = 'acs',
    ): Observable<IService[]> {
        const param = new Array();

        param.push('orderBy=' + orderBy);

        if (beginDate) {
            param.push('beginDate=' + dateToText(new Date(beginDate)));
        }

        if (endDate) {
            param.push('endDate=' + dateToText(new Date(endDate)));
        }
        if (pStart && pEnd) {
            param.push('start=' + pStart);
            param.push('end=' + pEnd);
        }

        const pr = param.join('&');
        const url = '/service/patient?' + pr;
        return this.httpNew.get<Array<IService>>(url, null);
    }

    /**
     * Получить список услуг - количество записей
     */

    public getServicesSize(
        beginDate: Date | null,
        endDate: Date | null,
    ): Observable<IServiceSize> {
        const param = new Array();

        if (beginDate) {
            param.push('beginDate=' + dateToText(new Date(beginDate)));
        }

        if (endDate) {
            param.push('endDate=' + dateToText(new Date(endDate)));
        }

        const pr = param.join('&');
        const url = '/service/patient/size?' + pr;
        return this.httpNew.get<IServiceSize>(url, null);
    }

    // /** Ира: нигде не вызывается
    //  * Получить по событию список файлов
    //  */
    // public getHistoryFileList(
    //     eventId: number,
    //     eventType: string,
    // ): Observable<IResearchFileList[]> {
    //     return this.httpNew.get(
    //         `/api/history/event/${eventId}/type/${eventType}/files`,
    //         null,
    //     );
    // }
}
